import { render } from "./enrichment-preview.vue?vue&type=template&id=01ba801e"
import script from "./enrichment-preview.vue?vue&type=script&lang=js"
export * from "./enrichment-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__